import { render, staticRenderFns } from "./EditLabel.vue?vue&type=template&id=584452d8"
import script from "./EditLabel.vue?vue&type=script&lang=js"
export * from "./EditLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports